import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import FooterButtons from '../../components/Button/FooterButtons';
import './PrescriptionDetails.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClevertapReact from 'clevertap-react';
import lodashMap from 'lodash/map';
import lodashGet from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import * as actions from '../../actions';
import * as Constants from '../../constants';
import * as Helper from '../../utils/helper';
import * as Validations from '../../utils/validations';
import * as AnalyticsHelper from '../../utils/analyticsHelper';
import { sendToGTM } from '../../utils/gtmHelper';
import ImageGallery from '../../components/ImageGallery/ImageGallery';
import OrderSuccess from '../../components/OrderSuccess/OrderSuccess';
import ReviewShipment from '@components/ReviewShipment';
import OrderSuccessModal from '@components/OrderSuccessModal';
import {
  Modal,
  ModalBody,
  ModalFooter
} from 'react-modal-bootstrap';
import Dropdown from '../../components/Dropdown/Dropdown';
import Loader from '@components/Loader';


const initialState = {
  rxAvailability: undefined,
  rxDelivery: false,
  rxSms: false,
  rxEmail: false,
  baseIndex: 0,
  emailadd: '',
  doctorConsultationNotes: '',
  isValidEmail: true,
  placingOrder: false,
  diagnosticInterested: 0,
  orderPlacementReasons: [],
  selectedOrderPlacementReason: 1,
  isOpenReviewShipmentModal: false,
};

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const UPLOAD_RX = 1;
const SEND_UPLOAD_LINK = 2;
const DOCTOR_CONSULTATION = 3;

class PrescriptionDetails extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount() {
    this.props.actions.changeHeaderState(Constants.SET_RX_AVAILABILITY);
    this.props.actions.getPrescriptionImages();
    this.props.actions.getOrderPlacementReasons().then(res => {
      if (!res.status) {
        return;
      }
      this.setState({
        orderPlacementReasons: res.data
      });
    });
  }

  componentWillReceiveProps(newProps) {
    const pathname = window.location.pathname;
    const type = newProps.state.order && newProps.state.order.action && newProps.state.order.action.type;
    const oldType = this.props.state.order && this.props.state.order.action && this.props.state.order.action.type;
    const globalAction = newProps.state.action;

    switch (globalAction.type) {
      case Constants.CLOSE_THIS_TASK:
        this.cancelOrder();
        break;
      case Constants.PLACE_ORDER:
        globalAction.path == pathname && this.checkParamsAndPlaceOrder();
        break;
      case Constants.MOVE_BACKWARD:
        globalAction.path == pathname && this.backToAddress();
        break;
    }

    if (type === oldType) {
      return;
    }
    switch (type) {
      case Constants.CREATE_ORDER_SUCCESS:
      case Constants.CREATE_ORDER_FAILURE:
        this.openModal();
        break;
      default:
    }
  }

  componentDidUpdate() {
    const { rxAvailability } = this.state;
    const isRxUploadRequired = lodashGet(this.props.state, 'cart.data.isRxUploadRequired', true);
    if (!isRxUploadRequired && rxAvailability) {
      this.setState({
        rxAvailability: undefined
      });
    }
  }

  setEmailAdd(value) {
    this.setState({ isValidEmail: Validations.email(value) });
    this.setState({ emailadd: value });
  }

  setDoctorConsultationNotes(value) {
    this.setState({ doctorConsultationNotes: value });
  }

  setNode(value) {
    this.setState({ emailadd: value });
  }

  setRxDelivery() {
    this.setState({ rxDelivery: true, rxSms: false, rxEmail: false });
  }

  setRxSms() {
    this.setState({ rxSms: !this.state.rxSms });
  }

  setRxEmail() {
    this.setState({ rxEmail: !this.state.rxEmail });
  }

  backToAddress() {
    this.props.actions.setRxAvailability(this.state);
    browserHistory.push('/select-address');
  }

  placeOrder = () => {
    const { state } = this.props;
    if (this.state.placingOrder) {
      return;
    }
    const provideRxLater = {};
    const requestParams = {
      optForDoctorConsultation: 0
    };

    /** *** check for rx availability ****/
    switch (this.state.rxAvailability) {
      case UPLOAD_RX:
        let imageNames = [],
          pdfFiles = [];

        state.prescriptionImages.s3UploadLinks.forEach(file => {
          if (file.type === Constants.FILE_TYPE.image) {
            imageNames.push(file.key);
          }
          if (file.type === Constants.FILE_TYPE.pdf) {
            pdfFiles.push(file.key);
          }
        });
        requestParams.imagesNames = JSON.stringify(imageNames);
        requestParams.pdfFiles = JSON.stringify(pdfFiles);
        break;
      case DOCTOR_CONSULTATION:
        requestParams.optForDoctorConsultation = 1;
        break;
      case SEND_UPLOAD_LINK:
        if (this.state.rxEmail) {
          provideRxLater.email = this.state.emailadd;
        }
        if (this.state.rxSms) {
          const selectedAddress = state.address.data.find(add => (add.id === state.orderParams.selectedAddressId));
          provideRxLater.mobileNumbers = [selectedAddress && selectedAddress.contactNumber];
        }
        requestParams.provideRxLater = provideRxLater;
        break;
      default:
    }
    /** ***** Payment related params ******/
    requestParams.walletOptIn = state.orderParams.optForWallet ? 1 : 0;
    requestParams.refundOptIn = 1;
    requestParams.paymentId = +state.orderParams.paymentModeId;
    if (state.orderParams.paymentModeSubId) {
      requestParams.paymentSubId = +state.orderParams.paymentModeSubId;
    }
    /** *** check if promocode is applicable ******/
    if (lodashGet(state.cart, 'promocode.data.couponCode')) {
      requestParams.promoCode = state.cart.promocode.data.couponCode;
    }
    if (state.cart.data && state.cart.data.isRxUploadRequired) {
      requestParams.noPrescriptionOrder = true;
    }

    requestParams.addressId = state.orderParams.selectedAddressId;
    requestParams.isFromNewOrderFlow = true;
    requestParams.placementReason = this.state.selectedOrderPlacementReason;
    if (confirm('Are you sure you want to place this order ?')) {
      this.setState({ placingOrder: true });
      this.props.actions.createOrder(requestParams).then(res => {
        if (!res.status) {
          this.setState({ placingOrder: false });
          return;
        }
        const {
          address: { cityId },
          orders: { medicineOrder: { id: orderId } }
        } = res.data;
        this.addOrderSubstitutionLog(orderId);
        this.postSubstitutionReasons(orderId);
        this.setSessionOrderMap(orderId);

        if (this.state.diagnosticInterested == 1) {
          this.props.actions.setDiagnosticOptIn({ orderId, orderType: Constants.OrderTypeCodeMapping.atcOrder, cityId });
        }

        const profile = this.props.isCustomerAuthenticated.profile || null;

        if (profile && this.state.diagnosticInterested == 1 && this.props.state.customer) {
          const cleaverTapPayload = {
            id: profile.id,
            customer_name: profile.name,
            customer_phone: profile.mobileNumber,
            customer_city: this.props.state.customer.location.data.cityName,
            created_at: new Date(),
            source: 'ooc',
          };
          ClevertapReact.event('diagnostics_lead_ooc', cleaverTapPayload);
        }
      });
    } else {
      this.setState({ placingOrder: false });
    }
  }

  confirmPlaceOrderV5 = () => {
    if (confirm('Are you sure you want to place this order ?')) {
      this.setState({ placingOrder: true, isOpenReviewShipmentModal: false });
      const { rxAvailability, selectedOrderPlacementReason } = this.state;

      const requestParams = {
        hasOptedForTeleconsult: +(rxAvailability === DOCTOR_CONSULTATION),
        placementReason: this.state.orderPlacementReasons.find(
          reason => Number(reason.id) === Number(selectedOrderPlacementReason)
        ).name,
        rxUploadLater: rxAvailability === SEND_UPLOAD_LINK,
      };

      if (rxAvailability === UPLOAD_RX) {
        let images = [],
          pdfFiles = [];

        this.props.state.prescriptionImages.s3UploadLinks.forEach(file => {
          if (file.type.includes(Constants.FILE_TYPE.image)) {
            images.push(file.key);
          }
          if (file.type.includes(Constants.FILE_TYPE.pdf)) {
            pdfFiles.push(file.key);
          }
        });
        requestParams.images = images;
        requestParams.pdfFiles = pdfFiles;
      } else if (rxAvailability === SEND_UPLOAD_LINK) {
        requestParams.attributes = {
          emailId: this.state.emailadd || '',
        };
      }

      const {
        state: {
          cart: { deliveryPreferences: { shipments = [] } = [] },
        },
      } = this.props;

      requestParams.deliveryPreferences = shipments.map(shipment => {
        const selectedDeliveryOption = shipment.deliveryOptions.find(
          option => option.selected
        );
        return {
          shipmentId: shipment.id,
          optionId: selectedDeliveryOption.id,
        };
      });

      this.props.actions
        .placeOrderV5(requestParams)
        .then(res => {
          if (res.code === 0) {
            this.setState({
              order: {
                ...res,
                isError: true
              },
            });
            return;
          }
          if (this.state.diagnosticInterested == 1) {
            this.props.actions.setDiagnosticOptIn({
              orderId: res.orderId,
              orderType: Constants.OrderTypeCodeMapping.atcOrder,
            });
          }
          this.setState({
            order: res,
          });

          const profile = this.props.isCustomerAuthenticated.profile || {};

          if (
            profile &&
            this.state.diagnosticInterested == 1 &&
            this.props.state.customer
          ) {
            const cleaverTapPayload = {
              id: profile.id,
              customer_name: profile.name,
              customer_phone: profile.mobileNumber,
              customer_city: this.props.state.customer.location.data.cityName,
              created_at: new Date(),
              source: 'ooc',
            };
            ClevertapReact.event('diagnostics_lead_ooc', cleaverTapPayload);
          }
          this.addOrderSubstitutionLog(res.orderId);
          this.postSubstitutionReasons(res.orderId);
          this.setSessionOrderMap(res.orderId);
          const eventDetails = {
            page_name: 'ooc_cart',
            property_section_name: 'body',
            property_name: 'ooc_loyalty_recommendation_bar',
            property_cta: 'order_placed',
            action_type: 'click',
            page_load_id: `pageLoad_${Date.now()}`,
            property_click_id: `click_${Date.now()}`,
            ...AnalyticsHelper.getCommonPayloadForAnalytics(
              // eslint-disable-next-line react/prop-types
              this.props.state.customer, this.props.state.cart, this.props.state.user
            ),
          };
          const loyaltyItem = lodashGet(this.props.state.cart, 'data.loyaltyItem', '');
          if (loyaltyItem) {
            sendToGTM({
              eventLabel: 'c_loyalty_order_placed',
              eventDetails
            });
          }
        })
        .finally(() => {
          this.setState({ placingOrder: false });
        });
    }
  };

  placeOrderV5 = async () => {
    const {
      rxAvailability
    } = this.state;

    if (rxAvailability === UPLOAD_RX) {
      const resp = await this.initiateUploadToS3();
      if (Array.isArray(resp)) {
        this.confirmPlaceOrderV5();
      } else {
        window.alert('Error while uploading images, please try again.');
      }
    } else {
      this.confirmPlaceOrderV5();
    }
  }

  addOrderSubstitutionLog = orderId => {
    const {
      state: {
        cart: {
          substitutedItems = {},
          productIdIndexMap: { medicineProductIdMap = {} }
        },
        product = {},
      },
      actions: { addSubstitutionEventLog }
    } = this.props;

    const searchResult = (product.searchResults && product.searchResults.data && product.searchResults.data.products && product.searchResults.data.products.length > 0) ? product.searchResults.data.products : [];

    const cartSubstitutedItems = Object.values(substitutedItems)
      .filter(
        ({ substitutedProductDetails: { id: productId } }) =>
          medicineProductIdMap[productId] != undefined
      )
      .map(item => ({
        ...item,
        originalProduct:
          item.originalProductDetails && item.originalProductDetails.id
            ? searchResult.find(
              prod => prod.productId === item.originalProductDetails.id
            )
            : {},
      }));

    if (!cartSubstitutedItems || !cartSubstitutedItems.length || !orderId) {
      return;
    }

    const logData = cartSubstitutedItems.map(
      ({
        originalUcodeAvailability,
        originalUcode,
        substitutedUcode,
        originalProduct,
      }) => ({
        availability: originalUcodeAvailability,
        substituteType: Constants.TYPE_SUBSTITUTE,
        originalUcode,
        logType: Constants.LOG_TYPE_SUBSTITUTE_ADDED_TO_ORDER,
        substituteUcode: substitutedUcode,
        orderId,
        isOriginalFlipForGreen: !!(
          originalProduct &&
          originalProduct.substituteDetails &&
          originalProduct.substituteDetails.flip_for_green
        ),
        hasHighMarginSubstitutes: !!(
          originalProduct &&
          originalProduct.substituteDetails &&
          originalProduct.substituteDetails.has_higher_margin_substitutes
        ),
      })
    );


    addSubstitutionEventLog(logData);
  }

  postSubstitutionReasons = orderId => {
    const {
      state: { orderParams: { substitutionReasons } },
      actions: { postSubstitutionReasons }
    } = this.props;

    if (!substitutionReasons || !substitutionReasons.length || !orderId) {
      return;
    }

    postSubstitutionReasons({
      orderId,
      reasonIds: substitutionReasons
    });
  }

  setSessionOrderMap = orderId => {
    const {
      actions: { setSessionOrderMap }
    } = this.props;

    setSessionOrderMap({
      orderId: String(orderId),
    });
  }

  reset = () => {
    this.props.actions.setRxAvailability(initialState);
    this.setState(initialState);
  };

  cancelOrder = () => {
    if (confirm('Are you sure you want to cancel this order ?')) {
      this.reset();
      this.props.actions.cancelOrder();
      browserHistory.push('/customer-info');
    }
  }

  openModal = () => {
    this.setState({
      isOpen: true
    });
  };

  hideModal = () => {
    this.setState({
      isOpen: false
    });
    this.reset();
    this.props.actions.cancelOrder();
    browserHistory.push('/customer-info');
  };

  uploadFiles = files => {
    if (!files.length) {
      return;
    }
    lodashMap(files, file => {
      if (file.size > MAX_FILE_SIZE) {
        window.alert('Max file size allowed: 10MB');
        return;
      }
      this.props.actions.saveImagesInStore({
        id: parseInt(Math.random() * 10000),
        file,
        url: window.URL.createObjectURL(file),
        type: file.type,
      });
    });
    this.fileInput.value = '';
  }

  initiateUploadToS3 = () => {
    const { prescriptionImages: { uploadedImages } } = this.props.state;
    let imgCount = 0,
      pdfCount = 0;

    uploadedImages.forEach(value => {
      if (value.type.indexOf(Constants.FILE_TYPE.pdf) !== -1) {
        pdfCount++;
      } else {
        imgCount++;
      }
    });

    return this.props.actions.fetchS3UploadLinks(imgCount, pdfCount, this.props.state.customer.omsEnabled)
      .then(res => {
        if (this.props.state.customer.omsEnabled) {
          const { urls } = res;
          return Helper.uploadImagesToS3(urls, uploadedImages);
        }
        const { data: s3Links, status } = res;
        if (!status) {
          throw new Error('Error while fetching upload links');
        }
        return Helper.uploadImagesToS3(s3Links, uploadedImages);
      });
  }

  handleTryAgain = error => {
    delete error.isError;
    this.setState({ isOpen: false });
    Raven.captureException('CREATE_ORDER_RETRY', {
      extra: {
        ERROR: error,
        USER_DATA: this.props.state.user.data,
        CUSTOMER_ACCESS_TOKEN: lodashGet(this.props.state, 'customer.customerDetails.data.accessToken'),
      }
    });
    if (this.props.state.customer.omsEnabled) {
      this.props.actions.getCartItemsV5().then(() => {
        this.placeOrderV5();
      });
    } else {
      this.props.actions.getCartItems().then(() => {
        this.checkParamsAndPlaceOrder();
      });
    }
  }

  checkParamsAndPlaceOrder = () => {
    const {
      prescriptionImages: { uploadedImages },
      cart,
      address,
    } = this.props.state;
    const isPathlabCity = lodashGet(address, 'selectedCity.isPathlab', false);
    const {
      rxEmail,
      rxSms,
      isValidEmail,
      rxAvailability,
      emailadd,
      diagnosticInterested
    } = this.state;

    if (isEmpty(cart) || !cart.data || cart.data.itemsCount === 0) {
      alert('Cart Empty! Please add products before proceeding.');
      return;
    }

    if (cart.data.isRxUploadRequired && !rxAvailability) {
      window.alert('Please select a valid Rx option');
      return;
    }

    if (isPathlabCity && !diagnosticInterested) {
      alert('Please select diagnostic refill');
      return;
    }

    switch (rxAvailability) {
      case UPLOAD_RX:
        if (!uploadedImages.length) {
          window.alert('Please upload images or choose other Rx option');
          return;
        }
        return this.initiateUploadToS3()
          .then(this.placeOrder)
          .catch(() => {
            window.alert('Error while uploading images, please try again.');
          });
      case SEND_UPLOAD_LINK:
        if (!rxEmail && !rxSms) {
          window.alert('Please select either email or SMS options.');
          return;
        } else if (rxEmail && (!emailadd || !isValidEmail)) {
          window.alert('Please enter a valid email address.');
          return;
        }
        return this.placeOrder();
      case DOCTOR_CONSULTATION:
        return this.placeOrder();
      default:
        this.placeOrder();
    }
  }

  handleProceedBtn = () => {
    if (this.props.state.customer.omsEnabled) {
      const {
        prescriptionImages: { uploadedImages },
        cart,
        address
      } = this.props.state;

      const {
        rxEmail,
        rxSms,
        isValidEmail,
        rxAvailability,
        emailadd,
        diagnosticInterested
      } = this.state;

      const isPathlabCity = lodashGet(address, 'selectedCity.isPathlab', false);

      if (isEmpty(cart) || !cart.data || cart.data.itemsCount === 0) {
        alert('Cart Empty! Please add products before proceeding.');
        return;
      }

      if (cart.data.isRxUploadRequired && !rxAvailability) {
        window.alert('Please select a valid Rx option');
        return;
      }

      if (isPathlabCity && !diagnosticInterested) {
        alert('Please select diagnostic refill');
        return;
      }

      switch (rxAvailability) {
        case UPLOAD_RX:
          if (!uploadedImages.length) {
            window.alert('Please upload images or choose other Rx option');
            return;
          }
          break;
        case SEND_UPLOAD_LINK:
          if (!rxEmail && !rxSms) {
            window.alert('Please select either email or SMS options.');
            return;
          } else if (rxEmail && (!emailadd || !isValidEmail)) {
            window.alert('Please enter a valid email address.');
            return;
          }
          break;
        default:
      }

      this.setState({
        isOpenReviewShipmentModal: true,
      });
    } else {
      this.checkParamsAndPlaceOrder();
    }
  }

  closeReviewShipmentModal = () => {
    this.setState({
      isOpenReviewShipmentModal: false,
    });
  }

  generateSurveyLink = () => {
    const { user, customer, order } = this.props.state;
    return Helper.generateSurveyLink(user, customer, order);
  }

  onChangeOption = selectedOrderPlacementReason => {
    this.setState({
      selectedOrderPlacementReason
    });
  }

  render() {
    // const enabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_enabled.svg';
    // const disabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_disabled.svg';
    // const disabledCheckBox = require('../../images/checkbox_disabled.svg');
    // const enabledCheckBox = require('../../images/checkbox_enabled.svg');
    const {
      rxAvailability,
      rxSms,
      rxEmail,
      emailadd,
      doctorConsultationNotes,
      isValidEmail,
      diagnosticInterested,
      selectedOrderPlacementReason,
      orderPlacementReasons
    } = this.state;
    const {
      order,
      address,
    } = this.props.state;
    const isPathlabCity = lodashGet(address, 'selectedCity.isPathlab', false);
    const { cart, prescriptionImages } = this.props.state;
    const { loading } = this.props.state.order;
    const { orders } = order.data && order.data.data || {};
    const prescriptionImagesArr = lodashGet(prescriptionImages, 'data.data.images', []);
    const uploadedImages = prescriptionImages.uploadedImages || [];
    const rxAvailabilityOptions = [
      { text: 'Upload Prescription', value: UPLOAD_RX },
      { text: 'Send Upload Link', value: SEND_UPLOAD_LINK },
      { text: 'No Prescription (Doctor Consultation)', value: DOCTOR_CONSULTATION },
    ];
    return (
      <div className="PrescriptionDetailsContainer">
        <div className="rxInfoContainer">
          <Modal isOpen={this.state.isOpen && !this.props.state.customer.omsEnabled} onRequestHide={this.hideModal.bind(this)} backdrop={false}>
            <ModalBody>
              {order.data && order.data.status != 1 && (<div className="alert alert-danger">
                <div className="errorText">{order.data && order.data.error && order.data.error.message || 'Something went wrong, Please try again.'}</div>
                <button className="btn btn-danger tryAgainBtn" onClick={() => this.handleTryAgain(order.data)}>Try Again</button>
              </div>)}
              {order.data && order.data.status == 1 && <OrderSuccess orderDetails={orders} />}
            </ModalBody>
            <ModalFooter>
              <button className="btn btn-default nextOrderBtn" onClick={this.hideModal.bind(this)}>
                SERVE NEXT ORDER
              </button>
              {order.data && order.data.status == 1 && <div className="surveyLink">
                <a rel="noopener noreferrer" target="_blank" href={this.generateSurveyLink()}>Take Survey</a>
              </div>}
            </ModalFooter>
          </Modal>
          {(cart.data && cart.data.isRxUploadRequired) ? <div>
            <div className="rxAvailabilityContainer">
              <div className="rxAvailabilityText">Is Rx available with customer?</div>
              <div className="rxAvailabilityOptions">
                {rxAvailabilityOptions.map(({ text, value }) => (<div key={text} className="optionContainer">
                  <input id={`rx-availability-${value}`} checked={rxAvailability === value} type="radio" key={text} name="rx-a" value={value} onClick={() => this.setState({ rxAvailability: value })} />
                  <label htmlFor={`rx-availability-${value}`}>{text}</label>
                </div>))}
              </div>
            </div>
            {(rxAvailability === SEND_UPLOAD_LINK) && <div className="sendRxOptionsContainer">
              <div className="sendRxOptionsText">Available/Send Upload Rx Via</div>
              <div className="sendRxOptions">
                <div className="optionContainer">
                  <input id="send-sms-link-checkbox" type="checkbox" checked={rxSms ? true : ''} onClick={this.setRxSms.bind(this)} />
                  <label htmlFor="send-sms-link-checkbox">Send Upload Rx via SMS</label>
                </div>
                <div className="optionContainer">
                  <input id="send-email-link-checkbox" type="checkbox" checked={rxEmail ? true : ''} onClick={this.setRxEmail.bind(this)} />
                  <label htmlFor="send-email-link-checkbox">Send Upload Rx via Email</label>
                </div>
              </div>
            </div>}
            {(rxAvailability === SEND_UPLOAD_LINK) && rxEmail && <div className="EmailAddressContainer">
              <div className="EmailAddressHeader">Email Address</div>
              <input
                type="email"
                className="EmailInput"
                value={emailadd}
                row="1"
                onChange={event => this.setEmailAdd(event.target.value)}
              />
              {!isValidEmail && <div className="errorMsg">Please Enter Valid Email</div>}
            </div>}
            {(rxAvailability === DOCTOR_CONSULTATION) && <div className="doctorConsultationContainer">
              <div className="doctorConsultationText">This order will be assigned for Doctor Consultation</div>
              {false && <div className="doctorConsultationSubText">Notes</div>}
              {false && <input
                type="email"
                className="doctorConsultationTextbox"
                value={doctorConsultationNotes}
                onChange={event => this.setDoctorConsultationNotes(event.target.value)}
                placeholder="Mention preferred date, time and language of customer for doctor consultation."
              />}
            </div>}
            {(prescriptionImagesArr && prescriptionImagesArr.length > 0) && <div className="PastImageGallery">
              <div className="rxGalleryTitle">Previously Uploaded Prescription(s)</div>
              <ImageGallery globalAction={this.props.state.action} images={prescriptionImagesArr} />
            </div>}
            {(rxAvailability === UPLOAD_RX) && <div className="uploadRxContainer">
              <div className="rxGalleryTitle">Upload Prescription(s)</div>
              <input
                style={{ display: 'none' }}
                type="file"
                ref={e => this.fileInput = e}
                onChange={event => this.uploadFiles(event.target.files)}
                accept=".png, .PNG, .jpg, .JPG, .jpeg, .JPEG, .pdf, .PDF"
                multiple
              />
              <button
                className="btn uploadRxBtn"
                onClick={() => this.fileInput.click()}
              >
                Upload Prescription
              </button>
              {(uploadedImages.length > 0) && <ImageGallery
                globalAction={this.props.state.action}
                images={uploadedImages}
                onDelete={this.props.actions.deleteImageFromStore}
              />}
            </div>}
          </div> :
            <div><div className="NoPrescriptionsRequired">No prescriptions Required</div>
              {(prescriptionImagesArr && prescriptionImagesArr.length > 0) && <div className="PastImageGallery">
                Previously Uploaded Prescription(s)
                <ImageGallery globalAction={this.props.state.action} images={prescriptionImagesArr} />
              </div>}
            </div>}

          {isPathlabCity && <div className="diagnosticPitch">
            <div className="pitchTitle">Diagnostic Pitch</div>
            <div className="pitchSubSection">
              <div className="pitchSubtitle">Customer interested in Diagnostic Services?</div>
              <div className="optionsContainer">
                <label>
                  <input checked={diagnosticInterested == 1 ? true : ''} type="radio" name="diagnostic" value={1} onClick={() => this.setState({ diagnosticInterested: 1 })} />
                  Yes, Interested
                </label>
                <label>
                  <input checked={diagnosticInterested == 2 ? true : ''} type="radio" name="diagnostic" value={2} onClick={() => this.setState({ diagnosticInterested: 2 })} />
                  Not Interested
                </label>
              </div>
            </div>
          </div>}

          <div className="orderPlacementReason">
            <div className="reasonTitle">Order Placement Reason</div>
            <Dropdown
              selectedOption={selectedOrderPlacementReason}
              list={orderPlacementReasons}
              onChangeOption={this.onChangeOption}
            />
          </div>
        </div>
        {
          this.state.isOpenReviewShipmentModal && (
            <ReviewShipment
              close={this.closeReviewShipmentModal}
              data={{
                hasOptedForTeleconsult: +(
                  rxAvailability === DOCTOR_CONSULTATION
                ),
                rxUploadLater: +(rxAvailability === SEND_UPLOAD_LINK),
                newImageUploaded: +(rxAvailability === UPLOAD_RX),
                placementReason: this.state.orderPlacementReasons.find(
                  reason => Number(reason.id) === Number(selectedOrderPlacementReason)
                ),
              }}
              placeOrderV5={this.placeOrderV5}
            />
          )
        }
        {
          this.state.isOpen &&
          this.props.state.customer.omsEnabled &&
          this.state.order && (
            <OrderSuccessModal
              orderInfo={this.state.order}
              hideModal={this.hideModal}
              handleSurveyClick={this.handleSurveyLinkClick}
              surveyHref={this.generateSurveyLink()}
              handleTryAgain={this.handleTryAgain}
            />
          )
        }
        {
          this.state.placingOrder && <Loader />
        }
        <FooterButtons
          backBtnText="Back to Delivery Address"
          backBtnClick={() => this.backToAddress()}
          proceedBtnClick={() => this.handleProceedBtn()}
          proceedBtnText={loading ? 'Loading...' : this.props.state.customer.omsEnabled ? 'Review Shipments' : 'Place Order'}
          cancelBtnClick={() => this.cancelOrder()}
          cancelBtnText="Cancel Order"
        />
      </div>
    );
  }
}

export default connect(state => ({
  state
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(PrescriptionDetails);
